// API
export const GET_INSTITUTIONS_LIST_API = '/products/productsGroups';
export const GET_INSTITUTION_DETAILS_API = '/products/productGroups/:uuid';

// Queries
export const QUERY_INSTITUTIONS_LIST = 'QUERY_INSTITUTIONS_LIST';
export const QUERY_INSTITUTION_DETAILS = 'QUERY_INSTITUTION_DETAILS';
